import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M12 19H5L5.007 12H7V17H12V19ZM18.992 12H17V7H12V5H19L18.992 12Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Expand"
);
